import { useTranslation } from "react-i18next";
import "./closeBetaBadge.scss";

const CloseBetaBadge: React.FC = () => {
  const { t } = useTranslation();

  return (
    <small className="close-beta-badge">{t("AI_ASSISTANT_CLOSE_BETA")}</small>
  );
};

export default CloseBetaBadge;
